/* import __COLOCATED_TEMPLATE__ from './time-dropdown.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { format, parse, differenceInMinutes, startOfDay, addMinutes } from 'date-fns';
import generateTimeIntervalArray from '@dashboard/shared-ui/utils/generate-time-interval-array';
import { DATE_FNS_SHORT_TIME_FORMAT } from '@dashboard/shared-ui/utils/time-dropdown';
/**
 * converts time string to minutes e.g.
 * - 12:00 am -> 0
 * - 12:15 am -> 15
 * - 1:00 am -> 60
 * - 1:00 pm -> 780
 * - 11:59 pm -> 1439
 * @param timeStr string
 * @returns number
 */
function timeToMinutes(timeStr) {
  const referenceDate = new Date(0);
  const parsedTime = parse(timeStr, DATE_FNS_SHORT_TIME_FORMAT, referenceDate);
  const startOfTheDay = startOfDay(referenceDate);
  return differenceInMinutes(parsedTime, startOfTheDay);
}

/**
 * converts minutes to time string e.g.
 * - 0 -> 12:00 am
 * - 15 -> 12:15 am
 * - 60 -> 1:00 am
 * - 780 -> 1:00 pm
 * - 1439 -> 11:59 pm
 * @param minutes number
 * @returns string
 */
function minutesToTime(minutes) {
  const today = new Date(0);
  const midnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const timeDate = addMinutes(midnight, minutes);
  return format(timeDate, DATE_FNS_SHORT_TIME_FORMAT);
}
let TimeDropdown = (_class = class TimeDropdown extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "localeTime", _descriptor2, this);
  }
  get currentTimeInMinutes() {
    if (!this.args.value) {
      return null;
    }
    return timeToMinutes(this.args.value);
  }
  get minTimeInMinutes() {
    if (!this.args.min) {
      return -1;
    }
    return timeToMinutes(this.args.min);
  }
  get times() {
    return generateTimeIntervalArray(this.localeTime).map((time, index) => {
      const minutes = index * 15;
      return {
        name: time,
        minutes
      };
    });
  }
  get isFieldInvalid() {
    if (!this.args.min || !this.args.value || !this.currentTimeInMinutes) {
      return false;
    }
    return this.currentTimeInMinutes < this.minTimeInMinutes;
  }
  onChange(event) {
    const minutes = Number.parseInt(event.detail.value, 10);
    const timeString = minutesToTime(minutes);
    this.args.onChange && this.args.onChange(timeString);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
export { TimeDropdown as default };